export default __webpack_public_path__ + "static/media/broccoli.e9fec32e.png";